import { Controller, useFormContext, useFormState } from "react-hook-form";
import { FunctionComponent, useState } from "react";
import { getError } from "../utils";
import {
  StyledCheckmark,
  StyledContainer,
  StyledInput,
  StyledLabel,
  StyledLock,
} from "./checkbox.styles";
import Field from "../field";
import Warning from "../warning";
import { faLock } from "components/icon-library";

interface CheckboxProps {
  name: string;
  label: string;
  disabled?: boolean;
  required?: boolean;
  string?: boolean;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({
  name,
  label,
  disabled = false,
  required = false,
  string = false,
}) => {
  // other states
  const [hover, toggleHover] = useState(false);
  const [focus, toggleFocus] = useState(false);
  const { control, setValue, trigger } = useFormContext();
  const { errors } = useFormState();

  const onChange = (e: any) => {
    // don't change, if disabled
    if (disabled) {
      return;
    }

    let value = e.target.checked;
    if (string) {
      value = value === true ? "yes" : "no";
    }

    // set the value to state (not sure if needed?)
    setValue(name, value);

    // trigger validation
    trigger(name);
  };

  const error = getError(errors, name);

  return (
    <Controller
      key={name}
      name={name}
      control={control}
      render={({ field: { ref, ...fieldProps } }) => {
        let checked = fieldProps.value;
        if (string) {
          checked = fieldProps.value === "yes";
        }
        return (
          <Field>
            <StyledContainer
              $hover={hover}
              $disabled={disabled}
              onMouseEnter={() => toggleHover(disabled ? false : true)}
              onMouseLeave={() => toggleHover(false)}
            >
              <StyledLabel name={name} required={required} disabled={disabled}>
                {label}
              </StyledLabel>
              <StyledInput
                key={name}
                id={`id_${name}`}
                ref={ref}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                name={fieldProps.name}
                // some aria flags
                aria-required={required}
                aria-label={label}
                aria-invalid={error !== undefined}
                type="checkbox"
                $focus={focus}
                onFocus={() => toggleFocus(true)}
                onBlur={() => {
                  toggleFocus(false);
                }}
              />
              {disabled === true && <StyledLock icon={faLock} />}
              {disabled === false && <StyledCheckmark />}
            </StyledContainer>
            <Warning name={name} />
          </Field>
        );
      }}
    />
  );
};

export default Checkbox;
